<template>
    <div class="container">
        <div class="row">
            <div class="col-12 py-3">
                <h4>Who we are</h4>
                
                <div class="my-4">
                    <p>
                        aNewItem is a 100% online marketplace. A platform where our customers (mostly overseas) buy items directly from the USA and have it shipped to them at their preferred pace.
                        As our slogan reads <em class="font-weight-bold text-dark-green">giving international items a new home</em>, we've been finding items new homes since 2018 
                        and we have plans of continuing this service for as long as human needs exists.
                    </p>
                    <p>
                        We are quite a young and growing team, we work daily to ensure that price or distance won't be the reason our customers can't get that quality item they need! 
                        <br>We sell neatly pre-owned, high quality items from the USA.
                    </p>
                    <p>
                        To partner or get in touch shoot us an email on <span class="font-weight-bold">{{anewitemEmail}}</span>
                        <br>We'll love to hear from you! <span class="font-weight-bold text-dark-green">#TeamAnewitem</span>
                    </p>
                    <p class="my-5">
                        <router-link :to="{ name: 'home' }" class="btn btn-light-green">
                            Continue Shopping
                        </router-link>
                    </p>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { webpageTitle } from '@/store/dry'
import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: "About",
    computed: {
        anewitemEmail() {
            return `${process.env.VUE_APP_ANI_MAIL}`
        }
    },
    created() {
        webpageTitle(`About us`)
        this.$emit('update:layout', LayoutGeneral);
    }
}
</script>